module.exports = __webpack_public_path__ + "static/media/error-500-flags.08f82f06.png";